










import { Vue, Component } from 'vue-property-decorator';
import ReportesSerieBase from './ReporteSerieBase.vue';

@Component({
  components: { ReportesSerieBase },
})
export default class EquiposEnTerrenoPantalla extends Vue {}
